import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAppStateStore } from '@/features/application'
import { typeContextCourantToContextAppType } from '@/features/auth/context-app/types/ContextApp'
import type { RouteName } from '@/router/route-name'

export function useNavigationTabs() {
  const router = useRouter()
  const route = useRoute()
  const appState = useAppStateStore()

  const getRouteByName = (name: RouteName) => router.getRoutes().find((r) => r.name === name)

  // TODO : A revoir, pas la bonne méthode
  const isAccessible = (name: RouteName) => !getRouteByName(name)?.meta?.requiresAdmin || appState.estAdmin

  const parent = computed(() => route.matched.at(-2))

  const tabs = computed(
    () =>
      parent.value?.children
        ?.filter((c) => isAccessible(c.name as RouteName))
        ?.map((c) => ({
          tabKey: (c.meta?.tabLabel as string) ?? (c.name as string),
          routeName: c.name as RouteName,
        })) ?? [],
  )

  const getTabsTitle = (name: RouteName) => tabs.value.find((t) => t.routeName === name)?.tabKey as string

  const getTabsRoute = (tabKey: string) => tabs.value.find((t) => t.tabKey === tabKey)?.routeName

  const goToTab = (tabKey: string) => {
    const routeName = getTabsRoute(tabKey)
    if (!routeName) return
    router.push({
      name: routeName,
      params: { context: typeContextCourantToContextAppType(appState.contextCourant) },
      query: route.query,
    })
  }

  return { tabs, goToTab, getTabsTitle }
}
